import { mapState } from 'vuex'
import { Preferencias } from '@/utils/preferencias'

export const preferencias = {
  data() {
    return {
      preferencias: null,
    }
  },
  computed: {
    ...mapState('auth', ['empresaAtual']),
  },
  created() {
    const empresaId = this.empresaAtual?.public_id
    this.preferencias = new Preferencias(empresaId)
  },
}
